import { atom, createStore } from 'jotai';

export const leadIntegrationEnabledAtom = atom(false);

export const authenticatedAtom = atom(false);

export const codWebAtom = atom('');

export type SalesforceOpenCtiStatus =
  | 'idle'
  | 'connecting'
  | 'reconnecting'
  | 'ready';

export const salesforceOpenCtiStatusAtom =
  atom<SalesforceOpenCtiStatus>('idle');

export const store = createStore();

export const outboundCallJournalEnabledAtom = atom(false);
